import React, { FC } from 'react';
import ExpandIcon from '@mui/icons-material//Add';
import ContractIcon from '@mui/icons-material//Minimize';
import { styled } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { SYSTEM_EXPAND, USER_EXPAND } from 'common/actions/row-groups/types';

const PREFIX = 'CollapsibleIcon';

const classes = {
  collapseButton: `${PREFIX}-collapseButton`,
  collapseIcon: `${PREFIX}-collapseIcon`,
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [`&.${classes.collapseButton}`]: {
    padding: theme.spacing(0.4),
  },

  [`& .${classes.collapseIcon}`]: {
    fontSize: '1.2rem',
  },
}));

interface CollapsibleIconProps {
  rowGroups?: Record<string, string>;
  alias: string;
  toggleRows: () => void;
}

const expandActions = [USER_EXPAND, SYSTEM_EXPAND];

const CollapsibleIcon: FC<CollapsibleIconProps> = ({ rowGroups, alias, toggleRows }) => (
  <StyledIconButton color="primary" size="small" className={classes.collapseButton} onClick={toggleRows}>
    {rowGroups && expandActions.includes(rowGroups[alias]) ? (
      <ContractIcon className={classes.collapseIcon} />
    ) : (
      <ExpandIcon className={classes.collapseIcon} />
    )}
  </StyledIconButton>
);

export default CollapsibleIcon;
